function getRetailStoreInfoByLatLng (position) {

	return fetch(`/api/storeavailability/StoreInfo/latlong/${position.coords.latitude},${position.coords.longitude}/`).then((response) => response.json());

}

export default getRetailStoreInfoByLatLng;
